if ( typeof SplitScreenSlider !== 'function' ) {

	class SplitScreenSlider extends HTMLElement {

		constructor(){
			
			super();

			this.mount();
			this.RESIZE_SliderHelper = debounce(()=>{
				this.unmount();
				this.mount();
			}, 300);
			window.addEventListener('resize', this.RESIZE_SliderHelper, {passive:true});

		}

		mount(){

			this._currentScroll = window.scrollY;
			this._headerHeight = document.getElementById('site-header').offsetHeight;

			this._fullWidth = this.classList.contains('layout-full') ? true : false;

			this._scrollEnabled = true;

			this._screenHeight = Math.min(window.innerHeight, window.screen.availHeight);

			this.slides = this.querySelectorAll('.slider-item'),
			this.slidesMedia = this.querySelectorAll('.slider-item-media > div');
			this.slidesBlackArray = this.querySelectorAll('.slider-item-media-overlay');
			this.headings = this.querySelectorAll('.box__heading');

			this.slides.forEach((elm, key)=>{
				if ( key == 0 || window.scrollY >= this._getOffsetTop(elm) ) {
					this.slidesMedia[key].style.height = `100%`;
				} else {
					this.slidesMedia[key].style.height = `0`;
				}
			});

			const cssSlider = this.querySelector('css-slider');

			cssSlider.addEventListener('ready', ()=>{
				const cssSliderSlides = this.querySelectorAll('.slider-item');
				const cssSlidesMediaElements = this.querySelectorAll('.slider-item-media-element');
				cssSlider.addEventListener('scroll', ()=>{
					const scrollX = -cssSlider.element.scrollLeft;
					cssSliderSlides.forEach((slide,i)=>{
						const media = cssSlidesMediaElements[i];
						if ( media ) {
							media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
						}
					});
				});
			});

			let previous = -1,
				currentOld = -1;

			this.SCROLL_SliderHelper = () => {

				const scrollTop = window.scrollY >= 0 ? window.scrollY : 0;
				const sliderTop = this._getOffsetTop(this);

				if ( this._scrollEnabled ) {

					let current = 0;

					if ( scrollTop + this._headerHeight - this._headerHeight < this._getOffsetTop(this) && ! this.classList.contains('back-to-normal') ) {
						this.classList.add('back-to-normal');
					}

					this.slides.forEach((elm, key)=>{
						if ( this._checkVisible(elm) ) {
							current = key;
						}
					});

					if ( current != currentOld ) {
						if ( this._currentScroll < scrollTop && currentOld > 0 ) {
							this._scrollMedia( current, this.slides[currentOld], this.slides[previous], this.slidesMedia[currentOld], this.slidesBlackArray[previous], this._screenHeight);
						} else if ( this._currentScroll > window.scrollY && currentOld > 0 ) {
							this._scrollMedia( current, this.slides[currentOld], this.slides[previous], this.slidesMedia[currentOld], this.slidesBlackArray[previous], 0);
						}
						currentOld = current;
						previous = current-1;
					}

					if ( current == 0 && scrollTop + this._screenHeight >= sliderTop + this.offsetHeight && ! this.classList.contains('back-to-normal') ) {
						this.classList.add('back-to-normal');
					} else if ( current > 0 ) {

						const scrollValue = ( scrollTop - sliderTop ) - this._screenHeight * ( current - 1 );
						if ( ! this.classList.contains('back-to-normal') ) {
							this._scrollMedia( current, this.slides[current], this.slides[previous], this.slidesMedia[current], this.slidesBlackArray[previous], scrollValue);

						}
						if ( scrollTop + this._screenHeight >= sliderTop + this.offsetHeight && ! this.classList.contains('back-to-normal') ) {
							this.classList.add('back-to-normal');
						} else if ( scrollTop + this._screenHeight < sliderTop + this.offsetHeight && this.classList.contains('back-to-normal' ) ) {
							this.classList.remove('back-to-normal');
						}

					}

				}

				this._currentScroll = scrollTop;

			}

			window.addEventListener('scroll', this.SCROLL_SliderHelper, {passive:true});
			this.SCROLL_SliderHelper();

		}

		unmount() {
			window.removeEventListener('scroll', this.SCROLL_SliderHelper);
		}

		_scrollMedia(index, currentSlide, previousSlide, currentSlideMedia, previousSlideOverlay, scrollValue) {

			if ( this._fullWidth ) {
				currentSlideMedia.style.clipPath = `polygon(0 ${window.innerHeight - scrollValue + 1}px, 100% ${window.innerHeight - scrollValue + 1}px, 100% 100%, 0% 100%)`;
			} else {
				currentSlideMedia.style.height = `${scrollValue}px`;
			}

			if ( previousSlideOverlay ) {
				previousSlideOverlay.style.opacity = `${Math.ceil( scrollValue * 30 / this._screenHeight ) / 100}`;
			}

		}

		_checkVisible(elm) {
			const rect = elm.getBoundingClientRect();
			const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
			return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
		}

		_getOffsetTop(elm) {
			if (!elm.getClientRects().length) {
				return 0;
			}
			const rect = elm.getBoundingClientRect();
			const win = elm.ownerDocument.defaultView;
			return rect.top + win.pageYOffset;
		}

	}

  if ( typeof customElements.get('split-screen-slider') == 'undefined' ) {
		customElements.define('split-screen-slider', SplitScreenSlider);
	}

}
document.addEventListener('DOMContentLoaded', function() {
  updateVideoSources();
  window.addEventListener('resize', debounce(updateVideoSources, 150));
});

function updateVideoSources() {
  const screenWidth = window.innerWidth;
  const desktopVideos = document.querySelectorAll('.desktop-video source');
  const mobileVideos = document.querySelectorAll('.mobile-video source');

  if (screenWidth >= 769) {
    desktopVideos.forEach(source => {
      source.setAttribute('src', source.getAttribute('data-src'));
      source.parentElement.load();
    });
    mobileVideos.forEach(source => source.removeAttribute('src'));
  } else {
    mobileVideos.forEach(source => {
      source.setAttribute('src', source.getAttribute('data-src'));
      source.parentElement.load();
    });
    desktopVideos.forEach(source => source.removeAttribute('src'));
  }
}

function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    const context = this, args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}
document.addEventListener('DOMContentLoaded', function() {
  updateMediaSources();
  window.addEventListener('resize', debounce(updateMediaSources, 150));
});

function updateMediaSources() {
  const screenWidth = window.innerWidth;
  // Mise à jour des sources vidéo
  const desktopVideos = document.querySelectorAll('.desktop-video source');
  const mobileVideos = document.querySelectorAll('.mobile-video source');

  // Réinitialiser toutes les vidéos
  resetVideos([...desktopVideos, ...mobileVideos]);

  if (screenWidth >= 769) {
    // Afficher les vidéos et images de préchargement pour le desktop
    updateVideos(desktopVideos, true);
    updatePreloadImages('.desktop-preload-image', true);
    updatePreloadImages('.mobile-preload-image', false);
  } else {
    // Afficher les vidéos et images de préchargement pour le mobile
    updateVideos(mobileVideos, true);
    updatePreloadImages('.desktop-preload-image', false);
    updatePreloadImages('.mobile-preload-image', true);
  }
}

function resetVideos(videos) {
  videos.forEach(source => {
    const video = source.parentElement;
    video.pause();
    source.removeAttribute('src'); // Enlever la source
    video.load(); // Recharger la vidéo
  });
}

function updateVideos(videos, shouldDisplay) {
  videos.forEach(source => {
    if (shouldDisplay) {
      source.setAttribute('src', source.getAttribute('data-src'));
      source.parentElement.load();
      source.parentElement.play();
    }
  });
}

function updatePreloadImages(selector, shouldDisplay) {
  const preloadImages = document.querySelectorAll(selector);
  preloadImages.forEach(img => {
    img.style.display = shouldDisplay ? 'block' : 'none';
  });
}

function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    const context = this, args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}
function initializeNavigationIndicators() {
    if (document.body.id === 'wholesale-pricing' || window.location.href.includes('wholesale-pricing') || window.location.href.includes('customization')) {
    console.log("Les indicateurs de navigation sont désactivés sur cette page.");
    return;
}

    const existingNavContainer = document.querySelector('.navigation-indicators-container');
    if (existingNavContainer) {
        existingNavContainer.remove();
    }

    const navContainer = document.createElement('div');
    navContainer.classList.add('navigation-indicators-container');
    document.body.appendChild(navContainer);

    navContainer.style.cssText = `
        position: fixed;
        bottom: 20px;
        right: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 1000;
    `;

    const sections = document.querySelectorAll('.slider-item');
    const announcementBar = document.querySelector('.announcement-bar'); // Peut être null si non présent

    sections.forEach((section, index) => {
        const indicator = document.createElement('div');
        indicator.style.cssText = `
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #ffffff;
            margin-bottom: 8px;
            cursor: pointer;
            opacity: 0.5;
            transition: opacity 0.3s ease ${index * 0.3}s, transform 0.3s ease;
        `;
        setTimeout(() => {
            indicator.style.opacity = 1;
        }, index * 300);

        navContainer.appendChild(indicator);

        indicator.addEventListener('click', () => section.scrollIntoView({ behavior: 'smooth' }));
        indicator.addEventListener('touchend', () => section.scrollIntoView({ behavior: 'smooth' }));

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const currentIndicator = navContainer.children[Array.from(sections).indexOf(entry.target)];
                if (entry.isIntersecting) {
                    currentIndicator.style.backgroundColor = '#1A1A1A'; // Actif
                    currentIndicator.style.transform = 'scale(1.5)'; // Augmentez la taille pour l'actif
                    currentIndicator.style.opacity = '1'; // Pleine visibilité pour l'actif

                    /*if (announcementBar) { // Conditionnellement afficher/masquer la barre d'annonces
                        if (index === 0) {
                            announcementBar.style.display = '';
                            announcementBar.classList.remove('hidden');
                        } else {
                            announcementBar.style.display = 'none';
                            announcementBar.classList.add('hidden');
                        }
                    }*/
                } else {
                    currentIndicator.style.backgroundColor = '#ffffff'; // Non actif
                    currentIndicator.style.transform = 'scale(1)'; // Taille normale pour le non actif
                    currentIndicator.style.opacity = '0.5'; // Moins visible pour le non actif
                }
            });
        }, { threshold: 0.5 });

        observer.observe(section);
    });
}

document.addEventListener('DOMContentLoaded', function() {
    if (document.body.classList.contains('page-critical-elements-loaded')) {
        initializeNavigationIndicators();
    } else {
        setTimeout(initializeNavigationIndicators, 100);
    }
});

let resizeTimeout;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initializeNavigationIndicators, 500);
});
